import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_ENTITLEMENTS } from '../../contracts';
import { setOwnHeidi2Access } from '../api/entitlements';

/**
 * PUT /api/v2/ml-scribe/access-entitlements/me/heidi-2-access
 * Turn the caller's own Heidi II access on or off. A team admin is refused, and
 * so is a team member asking for access back — their admin owns that.
 */
export function useMutateSetOwnHeidi2Access() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (enabled: boolean) => {
      // 204, so there is nothing to hand on. Returning the call would resolve
      // `mutateAsync` and `onSuccess` with the raw transport response.
      await setOwnHeidi2Access(enabled);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [GET_ENTITLEMENTS] });
    },
  });
}
